import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { InvoiceLineItem } from "@common/types/invoice";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { InvoiceAccountContent } from "../../InvoiceAccountContent";

export const AccountCell = memo(
    ({ row }: CellContext<ViewTableFeatures, InvoiceLineItem, unknown>) => (
        <ViewTableCell>
            <InvoiceAccountContent invoice={row.original.invoice} />
        </ViewTableCell>
    ),
);
